export default {"src":"/_next/static/media/linkedin_icon.94046eee.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};